<script setup>
/**
 * PipelineLossReasonSetting — Fase 4.5 frontend
 *
 * Simple toggle for `pipeline.settings['require_loss_reason']`.
 * Backend (PipelineCard#mark_as_lost!) raises 422 when on and reason
 * is blank. MarkAsLostModal reflects the requirement with an asterisk
 * on the reason label (separate component edit).
 */
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  pipeline: { type: Object, required: true },
});
const emit = defineEmits(['change']);

const { t } = useI18n();
const required = ref(props.pipeline?.settings?.require_loss_reason === true);

watch(required, val => {
  emit('change', { require_loss_reason: val });
});
</script>

<template>
  <section class="flex items-center justify-between">
    <div>
      <h4 class="text-label font-semibold text-n-slate-12">
        {{ t('PIPELINE.SETTINGS.REQUIRE_LOSS_REASON.TITLE') }}
      </h4>
      <p class="text-label-small text-n-slate-11 mt-0.5">
        {{ t('PIPELINE.SETTINGS.REQUIRE_LOSS_REASON.DESCRIPTION') }}
      </p>
    </div>
    <label class="inline-flex items-center cursor-pointer">
      <input v-model="required" type="checkbox" class="sr-only peer" />
      <span
        class="relative w-10 h-6 bg-n-alpha-3 peer-checked:bg-n-brand rounded-full transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:size-5 after:transition-transform peer-checked:after:translate-x-4"
      />
    </label>
  </section>
</template>
